import { z } from "zod";
export const dataVizVector3Schema = z.tuple([
    z.number().finite(),
    z.number().finite(),
    z.number().finite(),
]);
export const dataVizMetadataSchema = z.record(z.string(), z.unknown());
export const dataVizChartKindSchema = z.enum(["bar", "line", "grouped-bar", "ribbon-line"]);
export const dataVizChartAxisSchema = z.object({
    label: z.string().min(1).optional(),
    min: z.number().finite().optional(),
    max: z.number().finite().optional(),
});
export const dataVizChartPointVisualSchema = z.object({
    color: z.string().optional(),
    labelColor: z.string().optional(),
    labelBackgroundColor: z.string().optional(),
    labelBorderColor: z.string().optional(),
    opacity: z.number().finite().min(0).max(1).optional(),
});
export const dataVizChartPointSchema = z.object({
    id: z.string().min(1).optional(),
    key: z.string().min(1),
    label: z.string().min(1),
    value: z.number().finite().nonnegative(),
    normalizedValue: z.number().finite().min(0).max(1).optional(),
    count: z.number().finite().nonnegative().optional(),
    bucket: z.string().min(1).nullable().optional(),
    visual: dataVizChartPointVisualSchema.optional(),
    metadata: dataVizMetadataSchema.optional(),
});
export const dataVizChartSeriesSchema = z.object({
    id: z.string().min(1),
    label: z.string().min(1),
    color: z.string().optional(),
    points: z.array(dataVizChartPointSchema),
    metadata: dataVizMetadataSchema.optional(),
});
export const dataVizChartSchema = z.object({
    kind: dataVizChartKindSchema,
    title: z.string().min(1).optional(),
    axes: z.object({
        x: dataVizChartAxisSchema.optional(),
        y: dataVizChartAxisSchema.optional(),
    }).optional(),
    series: z.array(dataVizChartSeriesSchema),
    metadata: dataVizMetadataSchema.optional(),
});
export const dataVizNodeVisualSchema = z.object({
    color: z.string().optional(),
    emissiveColor: z.string().optional(),
    emissiveIntensity: z.number().finite().optional(),
    labelColor: z.string().optional(),
    labelBackgroundColor: z.string().optional(),
    labelBorderColor: z.string().optional(),
    opacity: z.number().finite().min(0).max(1).optional(),
    roughness: z.number().finite().min(0).max(1).optional(),
    metalness: z.number().finite().min(0).max(1).optional(),
    size: z.number().finite().positive().optional(),
    shape: z.enum([
        "sphere",
        "box",
        "cylinder",
        "octahedron",
        "tetrahedron",
        "dodecahedron",
    ]).optional(),
    icon: z.string().optional(),
});
export const dataVizEdgeVisualSchema = z.object({
    color: z.string().optional(),
    opacity: z.number().finite().min(0).max(1).optional(),
    width: z.number().finite().positive().optional(),
    dashed: z.boolean().optional(),
    curve: z.enum(["auto", "straight", "quadratic"]).optional(),
});
export const dataVizNodeSchema = z.object({
    id: z.string().min(1),
    kind: z.string().min(1),
    label: z.string().min(1),
    detail: z.string().optional(),
    status: z.string().optional(),
    position: dataVizVector3Schema.optional(),
    visual: dataVizNodeVisualSchema.optional(),
    metadata: dataVizMetadataSchema.optional(),
});
export const dataVizEdgeSchema = z.object({
    id: z.string().min(1).optional(),
    source: z.string().min(1),
    target: z.string().min(1),
    label: z.string().optional(),
    status: z.string().optional(),
    visual: dataVizEdgeVisualSchema.optional(),
    metadata: dataVizMetadataSchema.optional(),
});
export const dataVizGraphSchema = z.object({
    nodes: z.array(dataVizNodeSchema),
    edges: z.array(dataVizEdgeSchema),
    metadata: dataVizMetadataSchema.optional(),
});
//# sourceMappingURL=schemas.js.map